export var WalletType;
(function (WalletType) {
    WalletType["INJECTED"] = "INJECTED";
    WalletType["WALLET_CONNECT"] = "WALLET_CONNECT";
    WalletType["LEDGER"] = "LEDGER";
})(WalletType || (WalletType = {}));
//# sourceMappingURL=types.js.map